module.exports = __webpack_public_path__ + "img/559666.379cf9d8.png";